import { render, staticRenderFns } from "./ThemeDetailView.vue?vue&type=template&id=0f24c66a&scoped=true&"
import script from "./ThemeDetailView.vue?vue&type=script&lang=js&"
export * from "./ThemeDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ThemeDetailView.vue?vue&type=style&index=0&id=0f24c66a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f24c66a",
  null
  
)

export default component.exports